import createInformesSectionPage from "./SectionPageFactory";

const InformesTesoreriaDiferenciasPage = createInformesSectionPage(
  "Tesorería · Alertas de diferencias",
  "Comparativa de saldos declarados por cajero, supervisor y tesorería para detectar desvíos por etapa con su bitácora."
);

export default InformesTesoreriaDiferenciasPage;
